import React from 'react';
import i18n from './i18n';

const customerStatus = [
  {
    value: 'NewCreated',
    label: i18n.t('p.s.customerprofile.newclient', 'New Client'),
    tagBackgroundColor: '#17a2b81E',
    tagTextColor: '#17a2b8',
  },
  {
    value: 'Contacted',
    label: i18n.t('p.s.customerprofile.contacted', 'Contacted'),
    tagBackgroundColor: '#fd7e141E',
    tagTextColor: '#fd7e14',
  },
  {
    value: 'AppointmentScheduled',
    label: i18n.t(
      'p.s.customerprofile.appointment.scheduled',
      'Appointment Scheduled'
    ),
    tagBackgroundColor: '#007bff1E',
    tagTextColor: '#007bff',
  },
  {
    value: 'UnderTreatment',
    label: i18n.t('p.s.customerprofile.under.treatment', 'Under Treatment'),
    tagBackgroundColor: '#28a7451E',
    tagTextColor: '#28a745',
  },
  {
    value: 'FutureFollowUp',
    label: i18n.t('p.s.customerprofile.future.follow.up', 'Future Follow-up'),
    tagBackgroundColor: '#e0d8f7',
    tagTextColor: '#6610f2',
  },
  {
    value: 'Pending',
    label: i18n.t('p.s.customerprofile.pending', 'Pending'),
    tagBackgroundColor: '#fd397a1E',
    tagTextColor: '#fd397a',
  },
  {
    value: 'Declined',
    label: i18n.t('p.s.customerprofile.declined', 'Declined'),
    tagBackgroundColor: '#2125291E',
    tagTextColor: '#212529',
  },
];

const customerGender = [
  {
    value: 'Male',
    label: i18n.t('p.s.customerprofile.male', 'Male'),
  },
  {
    value: 'Female',
    label: i18n.t('p.s.customerprofile.female', 'Female'),
  },
  {
    value: 'NotToSay',
    label: i18n.t('p.s.customerprofile.prefer.not.to.say', 'Prefer not to say'),
  },
  {
    value: 'None',
    label: i18n.t('p.s.customerprofile.none', 'None'),
  },
];

const customerAge = [
  {
    value: 'AGE_16_20',
    label: i18n.t('p.s.client.report.age.16.19', 'Aged 16-19'),
  },
  {
    value: 'AGE_20_30',
    label: i18n.t('p.s.client.report.age.20.29', 'Aged 20-29'),
  },
  {
    value: 'AGE_30_40',
    label: i18n.t('p.s.client.report.age.30.39', 'Aged 30-39'),
  },
  {
    value: 'AGE_40_50',
    label: i18n.t('p.s.client.report.age.40.49', 'Aged 40-49'),
  },
  {
    value: 'AGE_50_60',
    label: i18n.t('p.s.client.report.age.50.59', 'Aged 50-59'),
  },
  {
    value: 'AGE_60_UP',
    label: i18n.t('p.s.client.report.age.60', 'Aged 60+'),
  },
];

const customerColumns = [
  {
    value: 'newClients',
    label: i18n.t('p.s.client.report.new.clients', 'New Clients'),
  },
  {
    value: 'returnClients',
    label: i18n.t('p.s.client.report.return.clients', 'Returning Clients'),
  },
];

const downloadFile = (binaryStream, fileName) => {
  const url = URL.createObjectURL(binaryStream);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export {customerStatus, customerGender, customerAge, customerColumns, downloadFile};
